<template>
    <div>
        <v-row v-if="view !== 'academy'">
            <v-col>
                <h1>Mine kurser</h1>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12" lg="6">
                <loader v-if="loading" />
                <template v-else>
                    <v-card v-for="(universe, universeIndex) in viewCourses" :key="universe._id" class="mb-4 course-list">
                        <v-card-title>
                            {{ universe._id }}                            
                        </v-card-title>
                        <v-card-text>
                            <v-expansion-panels v-model="selectedCourseIndex[universe._id]" flat>
                                <v-expansion-panel v-for="(course, courseIndex) in universe.courses" :key="course._id">
                                    <v-expansion-panel-header>
                                        <v-row no-gutters justify="space-between" align="center">
                                            <v-col cols="2">
                                                <v-icon v-if="course.lessons.every(lesson => lesson.agents[uniqueId].passed)" color="green">far fa-check-square</v-icon>
                                                <v-icon v-else-if="course.lessons.some(lesson => lesson.agents[uniqueId].passed)" color="yellow">far fa-minus-square</v-icon>
                                                <v-icon v-else color="red">far fa-square</v-icon>
                                            </v-col>
                                            <v-col cols="10">
                                                {{ course.name }}
                                            </v-col>
                                        </v-row>
                                    </v-expansion-panel-header>
                                    <v-expansion-panel-content>
                                        <v-list>
                                                <v-list-item-group v-model="selectedLessonIndex[universe._id]" class="grey lighten-5 mt-2">
                                                    <v-list-item
                                                        v-for="(lesson, lessonIndex) in course.lessons" :key="lesson._id"
                                                        :style="videoBorderStyle(lessonIndex)"                                                
                                                        @click="setSelectedLesson(universeIndex, courseIndex, lessonIndex)"
                                                    >
                                                            <v-list-item-icon>
                                                                <v-icon v-if="lesson.agents[uniqueId].passed" color="green">far fa-check-square</v-icon>
                                                                <v-icon v-else color="red">far fa-square</v-icon>
                                                            </v-list-item-icon>
                                                            <v-list-item-content>
                                                                <v-row no-gutters align="center">
                                                                    <v-col>{{ lesson.name }}</v-col>
                                                                    <v-col class="text-right">{{ lesson.chapters.length }} kapitler</v-col>
                                                                </v-row>
                                                            </v-list-item-content>
                                                    </v-list-item>
                                            </v-list-item-group>
                                        </v-list>
                                    </v-expansion-panel-content>
                                </v-expansion-panel>  
                            </v-expansion-panels> 
                        </v-card-text>
                    </v-card>
                </template>
            </v-col>
            <v-col v-if="!$vuetify.breakpoint.mobile" lg="6">
                <v-card>
                    <v-card-text v-if="selectedLesson">
                        <v-row>
                            <v-col class="flex-grow-0">
                                <v-btn to="/video" depressed outlined>
                                    <v-icon left>fa-eye</v-icon>
                                    Se video
                                </v-btn>
                            </v-col>
                            <v-col class="flex-grow-0">
                                <v-btn to="/test" depressed outlined :disabled="!selectedLesson.agents[uniqueId].completed">
                                    <v-icon left>fa-spell-check</v-icon>
                                    Tag test
                                </v-btn>
                            </v-col>
                            <v-spacer />
                        </v-row>
                        <v-divider />
                        <v-row>
                            <v-col>
                                <v-list class="striped-list">
                                    <v-list-item v-for="(file, index) in selectedLesson.files" :key="index" :style="videoBorderStyle(index)">
                                        <v-list-item-icon>
                                            <v-icon :color="($store.state.training.fileIcons[file.filename.split('.').reverse()[0]] || { color: '#000' }).color">
                                                {{ ($store.state.training.fileIcons[file.filename.split('.').reverse()[0]] || { icon: 'far fa-file' }).icon }}
                                            </v-icon>
                                        </v-list-item-icon>                            
                                        <v-list-item-title>
                                            {{ file.name }}
                                        </v-list-item-title>
                                        <v-list-item-action>
                                            <v-btn icon>
                                                <v-icon v-ripple color="primary" @click="downloadFile(file)">fa-download</v-icon>
                                            </v-btn>
                                        </v-list-item-action>
                                    </v-list-item>
                                </v-list>
                            </v-col>
                        </v-row>
                    </v-card-text>
                    <v-card-text v-else>
                        Vælg en lektion til venstre.
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
    </div>
</template>

<script>
let view = 'training'

export default {
    data () {
        return {
            view: view,
            loading: true,
            panel: null,
            courses: null,
            selectedCourseIndex: {},
            selectedLessonIndex: {}
        }
    },
    computed: {
        viewCourses () {
            return this.view === 'academy' ? this.courses.filter(course => course._id === 'Nysalgsakademi') : this.courses
        },
        uniqueId () {
            return this.$store.state.main.uniqueId
        },
        selectedLesson () {
            return this.$store.state.training.selectedLesson
        }
    },
    methods: {
        setSelectedLesson (universeIndex, courseIndex, lessonIndex) {
            this.selectedLessonIndex = {}
            this.selectedLessonIndex[this.courses[universeIndex]._id] = lessonIndex
            this.$store.state.training.selectedLesson =
                this.$store.state.training.view === 'academy'
                ? this.courses.find(course => course._id === 'Nysalgsakademi').courses[courseIndex].lessons[lessonIndex]
                : this.courses[universeIndex].courses[courseIndex].lessons[lessonIndex]
            if (this.$vuetify.breakpoint.mobile) {
                this.$store.state.training.view = this.view
                this.$router.push({ path: '/video' })
            }
        },
        async downloadFile ({ filename }) {
            const response = await this.$http().get(`training/file/${filename}`)
            const link = document.createElement('a')
            link.href = response.data
            link.click()
        },
        async getData () {
            this.loading = true
            const response = await this.$http().get(`user/${this.uniqueId}/training/courses`)
            this.courses = response.data
            this.loading = false
        },
        videoBorderStyle (index) {
            return index === 0
            ? 'border: 1px solid rgba(0, 0, 0, 0.12)'
            : 'border: 1px solid rgba(0, 0, 0, 0.12); border-top: 0;'
        }
    },
    created () {
        this.$store.state.training.selectedLesson = null
        this.$store.state.training.view = this.view
        this.getData()
    },
    beforeRouteEnter (to, from, next) {
        if (from.name === 'Academy') view = 'academy'
        next()
    }
}
</script>